import { render, staticRenderFns } from "./CambiosGuardia.vue?vue&type=template&id=6beed1aa"
import script from "./CambiosGuardia.vue?vue&type=script&lang=js"
export * from "./CambiosGuardia.vue?vue&type=script&lang=js"
import style0 from "./CambiosGuardia.vue?vue&type=style&index=0&id=6beed1aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports